import React from 'react';
import PropTypes from 'prop-types';

import css from './Published.module.scss';

import Icon from 'components/Icon';

import cn from 'classnames';

const Published = ({label, date, isFeatureArticle, className}) => (
    <div className={cn(css.published, {
        [css["-is-feature-article"]]: isFeatureArticle,
        [className]: className
    })}>
        <Icon className={css.icon} icon='calendar' />
        <p className={css.text}>{label} {date}</p>
    </div>
);

Published.propTypes={
    className: PropTypes.string,
    label: PropTypes.string,
    date: PropTypes.string,
    isFeatureArticle: PropTypes.bool
};
export default Published;


// WEBPACK FOOTER //
// ./src/components/Published/Published.jsx